export const FILTER_NAME = 'purchase-report'

export const NEW = 'new'
export const PROGRESS = 'progress'
export const COMPLETED = 'completed'
